import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Form, Row } from 'react-bootstrap'
import { Col } from 'reactstrap'
import Layout from 'shared/layouts/containers/Main'
import InputWrapper from 'shared/components/InputWrapper'
import BackButton from 'shared/components/BackButton'
import Footer from 'shared/components/Footer'
import getBrandContent from 'utils/getBrandContent'
import { axiosGet } from 'shared/api/axios'
import { apiUrls } from 'consts'
import { formatDate, formatDateTime, stringToDate } from 'utils/dateUtils'

const DeviceReplacementDetail: React.FC = () => {
  const { id } = useParams()
  const [showOverlay, setShowOverlay] = useState<boolean>(true)
  const [data, setData] = useState<any>({})

  useEffect(() => {
    axiosGet(`${apiUrls.deviceReplacements}/${id}`).then((response) => {
      setData(response.data)
      setShowOverlay(false)
    })
  }, [id])

  const field = (name: string) => ({
    value: data?.[name] ?? '',
    disabled: true,
    onChange: () => {},
  })

  const dateField = (name: string) => ({
    value: formatDate(stringToDate(data?.[name])) ?? '',
    disabled: true,
    onChange: () => {},
  })

  const dateTimeField = (name: string) => ({
    value: formatDateTime(stringToDate(data?.[name])) ?? '',
    disabled: true,
    onChange: () => {},
  })

  return (
    <Layout
      footerContent={<Footer />}
      brandContent={getBrandContent()}
      showOverlay={showOverlay}
      showCardHeader={true}
      showMinimizedBarButton={true}
      headerInsert={<BackButton url='/' text='All Devices' />}
    >
      <Form>
        <Row>
          <Col md='6'>
            <InputWrapper colAttributes={{ md: 12 }} label='MAC Address' name='mac_address' errors={{}}>
              <Form.Control type='text' {...field('mac_address')} />
            </InputWrapper>

            <InputWrapper colAttributes={{ md: 12 }} label='Serial #' name='serial_number' errors={{}}>
              <Form.Control type='text' {...field('serial_number')} />
            </InputWrapper>

            <InputWrapper colAttributes={{ md: 12 }} label='Label' name='label' errors={{}}>
              <Form.Control type='text' {...field('label')} />
            </InputWrapper>

            <InputWrapper colAttributes={{ md: 12 }} label='Device Type' name='type_name' errors={{}}>
              <Form.Control type='text' {...field('type_name')} />
            </InputWrapper>

            <InputWrapper colAttributes={{ md: 12 }} label='Manufacturer' name='manufacturer_name' errors={{}}>
              <Form.Control type='text' {...field('manufacturer_name')} />
            </InputWrapper>

            <InputWrapper colAttributes={{ md: 12 }} label='Model' name='model_name' errors={{}}>
              <Form.Control type='text' {...field('model_name')} />
            </InputWrapper>

            <InputWrapper colAttributes={{ md: 12 }} label='Carrier' name='carrier_name' errors={{}}>
              <Form.Control type='text' {...field('carrier_name')} />
            </InputWrapper>

            <InputWrapper colAttributes={{ md: 12 }} label='Site' name='site_name' errors={{}}>
              <Form.Control type='text' {...field('site_name')} />
            </InputWrapper>

            <InputWrapper colAttributes={{ md: 12 }} label='Cost Center' name='center_name' errors={{}}>
              <Form.Control type='text' {...field('center_name')} />
            </InputWrapper>
          </Col>

          <Col md='6'>
            <InputWrapper colAttributes={{ md: 12 }} label='Origin RMA #' name='origin_rma' errors={{}}>
              <Form.Control type='text' {...field('origin_rma')} />
            </InputWrapper>

            <InputWrapper colAttributes={{ md: 12 }} label='Owner' name='owner' errors={{}}>
              <Form.Control type='text' {...field('owner')} />
            </InputWrapper>

            <InputWrapper colAttributes={{ md: 12 }} label='Last Used By' name='last_used_by' errors={{}}>
              <Form.Control type='text' {...field('last_used_by')} />
            </InputWrapper>

            <InputWrapper colAttributes={{ md: 12 }} label='Last Used Date' name='last_used_date' errors={{}}>
              <Form.Control type='text' {...dateTimeField('last_used_date')} />
            </InputWrapper>

            <InputWrapper colAttributes={{ md: 12 }} label='Production Date' name='production_date' errors={{}}>
              <Form.Control type='text' {...dateField('production_date')} />
            </InputWrapper>

            <InputWrapper colAttributes={{ md: 12 }} label='Warranty Expiration' name='warranty_expiration_date' errors={{}}>
              <Form.Control type='text' {...dateField('warranty_expiration_date')} />
            </InputWrapper>

            <InputWrapper colAttributes={{ md: 12 }} label='Warranty Status' name='warranty_status' errors={{}}>
              <Form.Control type='text' {...field('warranty_status')} />
            </InputWrapper>

            <InputWrapper colAttributes={{ md: 12 }} label='Service Status' name='service_status_name' errors={{}}>
              <Form.Control type='text' {...field('service_status_name')} />
            </InputWrapper>

            <InputWrapper colAttributes={{ md: 12 }} label='RMA #' name='rma' errors={{}}>
              <Form.Control type='text' {...field('rma')} />
            </InputWrapper>

            <InputWrapper colAttributes={{ md: 12 }} label='Failure Reason' name='failure_name' errors={{}}>
              <Form.Control type='text' {...field('failure_name')} />
            </InputWrapper>

            <InputWrapper colAttributes={{ md: 12 }} label='Replaced Date' name='replaced_date' errors={{}}>
              <Form.Control type='text' {...dateField('replaced_date')} />
            </InputWrapper>

            <InputWrapper colAttributes={{ md: 12 }} label='Replaced By' name='replaced_by_name' errors={{}}>
              <Form.Control type='text' {...field('replaced_by_name')} />
            </InputWrapper>
          </Col>
        </Row>
      </Form>
    </Layout>
  )
}

export default DeviceReplacementDetail
